import React, { useEffect, useRef, useState } from "react";
import { Stack } from "@mui/material";
import Label from "src/components/Label";
import { CircularProgress } from "@mui/material";
import { useSnackbar } from "notistack";
import { makeStyles } from "@mui/styles";
import CustomConfirmation from "src/components/ModalPopover/Confirmation";
import {
  WorkoutTypeListingApi,
  deleteWorkoutTypeApi,
} from "src/DAL/workoutType/workoutType";
import { show_proper_words } from "src/utils/constant";
import CustomMUITable from "src/components/CustomMUITable";
import CustomPopoverNew from "src/components/CustomPopoverNew";
import AddOrUpdateGeneralType from "./AddOrUpdateGeneralType";

const useStyles = makeStyles(() => ({
  loading: {
    marginLeft: "50%",
    marginTop: "20%",
  },
}));

const tabs = {
  asc: "asc",
  desc: "desc",
};

export default function GeneralListingType({ type }) {
  const prevTypeRef = useRef(type);
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const [userList, setUserList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [deleteDoc, setDeleteDoc] = useState(null);
  const [openDelete, setOpenDelete] = useState(false);
  const [selectedTab, setSelectedTab] = useState(tabs.asc);
  const [open, setOpen] = useState(false);
  const [formType, setFormType] = useState("Add");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [pageCount, setPageCount] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [searchText, setSearchText] = useState("");

  const handleAgreeDelete = (value) => {
    setDeleteDoc(value);
    setOpenDelete(true);
  };

  const handleEdit = (value) => {
    setDeleteDoc(value);
    setFormType("Edit");
    setOpen(true);
  };

  const handleMenu = (item) => {
    const MENU_OPTIONS = [];

    if (item.action_by === "coach_user") {
      MENU_OPTIONS.push(
        {
          label: "Edit",
          icon: "akar-icons:edit",
          handleClick: handleEdit,
        },
        {
          label: "Delete",
          icon: "ant-design:delete-twotone",
          handleClick: handleAgreeDelete,
        },
      );
    }

    return MENU_OPTIONS;
  };

  const getWorkoutTypeListing = async (search) => {
    setIsLoading(true);
    const result = await WorkoutTypeListingApi(
      page,
      rowsPerPage,
      search,
      selectedTab,
      type,
    );
    if (result.code === 200) {
      let data = result.workout_types.map((item) => {
        return { ...item, MENU_OPTIONS: handleMenu(item) };
      });
      setUserList(data);
      setTotalCount(result.total_workout_types);
      setTotalPages(result.total_pages);
      setIsLoading(false);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
      setIsLoading(false);
    }
  };

  const handleDelete = async () => {
    setOpenDelete(false);
    const result = await deleteWorkoutTypeApi(deleteDoc._id);
    if (result.code === 200) {
      setUserList((old) => old.filter((item) => item._id !== deleteDoc._id));
      enqueueSnackbar(result.message, { variant: "success" });
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    if (newPage <= 0) {
      setPageCount(1);
    } else {
      setPageCount(newPage + 1);
    }
  };

  const handleChangePages = (event, newPage) => {
    if (newPage <= 0) {
      setPage(0);
      setPageCount(1);
    } else {
      setPage(newPage - 1);
      setPageCount(newPage);
    }
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const searchFunction = () => {
    setPage(0);
    setPageCount(1);
    localStorage.setItem(`${type}_type`, searchText);
    getWorkoutTypeListing(searchText);
  };

  const handleAddType = () => {
    setFormType("Add");
    setOpen(true);
  };

  useEffect(() => {
    const typeChanged = prevTypeRef.current !== type;
    prevTypeRef.current = type;
    let find_filter = localStorage.getItem(`${type}_type`);

    if (typeChanged) {
      setSearchText("");
    }
    if (find_filter) {
      setSearchText(find_filter);
    }

    getWorkoutTypeListing(
      typeChanged ? "" : find_filter ? find_filter : searchText,
    );
  }, [page, rowsPerPage, selectedTab, type]);

  const TABLE_HEAD = [
    {
      id: "action",
      label: "Action",
      type: "action",
      MENU_OPTIONS: "MENU_OPTIONS",
    },
    { id: "number", label: "#", type: "number" },
    { id: "title", label: " Title" },
    {
      id: "description",
      label: "Description",
      renderData: (data) => {
        return <div class="ellipsis-text">{data?.description || "N/A"}</div>;
      },
    },
    { id: "status", label: "Status", type: "row_status" },
  ];

  if (isLoading) {
    return <CircularProgress className={classes.loading} color="primary" />;
  }

  return (
    <>
      <CustomConfirmation
        openDelete={openDelete}
        setOpenDelete={setOpenDelete}
        title={"Are you sure you want to delete ?"}
        handleAgree={handleDelete}
      />
      <div className="container-fluid">
        <div className="row">
          <div className="col-12 col-lg-8">
            <h2>{type === "food" ? "Diet" : show_proper_words(type)} Type</h2>
          </div>
          <div className="col-12 col-lg-4 text-end">
            <button onClick={handleAddType} className="small-contained-button">
              Add Type
            </button>
          </div>
        </div>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mt={3}
          mb={1}
        >
          <div className="d-flex">
            <div className="me-2 pointer">
              <Label
                onClick={() => {
                  setPage(0);
                  setPageCount(1);
                  setSelectedTab(tabs.asc);
                }}
                variant={selectedTab === tabs.asc ? "ghost" : ""}
                style={{ width: 50, cursor: "pointer" }}
                color="info"
              >
                A-Z
              </Label>
            </div>
            <div className="me-2 pointer">
              <Label
                onClick={() => {
                  setPage(0);
                  setPageCount(1);
                  setSelectedTab(tabs.desc);
                }}
                variant={selectedTab === tabs.desc ? "ghost" : ""}
                style={{ width: 50, cursor: "pointer" }}
                color="info"
              >
                Z-A
              </Label>
            </div>
          </div>
        </Stack>
        <CustomMUITable
          TABLE_HEAD={TABLE_HEAD}
          data={userList}
          className="card-with-background"
          custom_pagination={{
            total_count: totalCount,
            rows_per_page: rowsPerPage,
            page: page,
            handleChangePage: handleChangePage,
            onRowsPerPageChange: handleChangeRowsPerPage,
          }}
          custom_search={{
            searchText: searchText,
            setSearchText: setSearchText,
            handleSubmit: searchFunction,
          }}
          pageCount={pageCount}
          totalPages={totalPages}
          handleChangePages={handleChangePages}
          pagePagination={true}
          rows_per_page_count={rowsPerPage}
        />
        <CustomPopoverNew
          isOpenPop={open}
          isClosePop={setOpen}
          title={
            <>
              {formType}{" "}
              {type === "nutrition" ? "Diet" : show_proper_words(type)} Type
            </>
          }
          componentToPassDown={
            <div className="px-2 pb-3">
              <AddOrUpdateGeneralType
                type={type}
                data={deleteDoc}
                formType={formType}
                setOpen={setOpen}
                reloadList={getWorkoutTypeListing}
              />
            </div>
          }
        />
      </div>
    </>
  );
}
